import React from 'react';
import styles from './Paginador.module.css';

const BOTON_PRIMERA = '<<';
const BOTON_ANTERIOR = '<';
const BOTON_SIGUIENTE = '>';
const BOTON_ULTIMA = '>>';

const Paginador = (props) => {
  const cantPaginas = props.cantPaginas;
  const cantBotones = props.cantBotones;
  const paginaActual = props.paginaActual;

  let paginaInicial = 0;
  if (paginaActual >= cantBotones || paginaActual >= cantPaginas) {
    paginaInicial = Math.floor(paginaActual / cantBotones) * cantBotones;
  }
  const botones = [];
  if (paginaActual >= cantBotones) {
    botones.push(BOTON_PRIMERA, BOTON_ANTERIOR);
  }
  let index;
  for (index = paginaInicial; index < Number(paginaInicial) + Number(cantBotones); index++) {
    botones.push(index + 1);
    if (index + 1 === cantPaginas) {
      break;
    }
  }
  if (index + 1 < cantPaginas) {
    botones.push(BOTON_SIGUIENTE, BOTON_ULTIMA);
  }

  const buttonClickHandler = (event) => {
    const boton = event.target.value;
    let nuevaPagina = null;
    switch (boton) {
      case BOTON_PRIMERA: {
        nuevaPagina = 0;

        break;
      }
      case BOTON_ANTERIOR: {
        nuevaPagina = paginaActual - cantBotones;

        break;
      }
      case BOTON_SIGUIENTE: {
        nuevaPagina = paginaActual + cantBotones;

        break;
      }
      case BOTON_ULTIMA: {
        nuevaPagina = cantPaginas - 1;

        break;
      }
      default: {
        nuevaPagina = Number(boton) - 1;
      }
    }
    if (nuevaPagina >= cantPaginas) {
      nuevaPagina = cantPaginas - 1;
    }
    if (nuevaPagina !== null) {
      props.onPaginaElegida(nuevaPagina);
    }
  };

  return (
    <React.Fragment>
      {cantPaginas > 1 && (
        <div className={`${styles.paginador}`}>
          {botones.map((boton) => (
            <input
              type="button"
              key={boton}
              className={`${styles.boton} ${
                Number(boton) === paginaActual + 1 && styles.presionado
              }`}
              value={boton}
              onClick={buttonClickHandler}
            />
          ))}
        </div>
      )}
    </React.Fragment>
  );
};

export default Paginador;
